import { apiUrl, api } from "../";

const url = `${apiUrl}/auth/user/admin`;

export const fetchMe = () => {
  return api(url, {
    method: "GET",
  });
};
